import { hasRole } from './authentication-functions'
import { SettingsContext } from '@/utilities/settings-context'
import axios from 'axios'

const canRequest = () => hasRole("Administrator") || hasRole("Moderator");

export const isPartialSponsoringEnabled = async (companyId: number) =>
{
  if (!canRequest())
  {
    return false
  }

  const response = await axios.get<boolean>(`${SettingsContext.getApiUrl('isPartialSponsoringEnabled')}?id=${companyId}`);

  return response.data;
}

export const getPartialSponsoringCompanyPoints = async (companyId: number): Promise<CompanyPoints> =>
{
  if (!canRequest())
  {
    return { enabled: false, points: 0 };
  }

  const response = await axios.get<CompanyPoints>(`${SettingsContext.getApiUrl('getPartialSponsoringCompanyPoints')}?id=${companyId}`);

  return response.data;
}

export const getPartialSponsoringJobsPoints = async (companyId: number) =>
{
  if (!canRequest())
  {
    return [];
  }

  const response = await axios.get<JobPoint[]>(`${SettingsContext.getApiUrl('getPartialSponsoringJobsPoints')}?id=${companyId}`);

  return response.data;
}

export const setPartialSponsoringJobsPoints = async (postingId: number, points: number) =>
{
  if (!canRequest())
  {
    return;
  }

  await axios.post(`${SettingsContext.getApiUrl('setPartialSponsoringPointsForJobPosting')}/${postingId}`, { points });
}

export const setPartialSponsoringAvailablePoints = async (companyId: number, points: number) => {
  if(!canRequest()) {
    return;
  }

  await axios.post(`${SettingsContext.getApiUrl('setPartialSponsoringAvailablePoints')}/${companyId}`, { points });
};

export const disablePartialSponsoring = async (companyId: number) => {
  if(!canRequest()) {
    return;
  }

  await axios.post(`${SettingsContext.getApiUrl('disablePartialSponsoring')}/${companyId}`);
};

export const enablePartialSponsoring = async (companyId: number) => {
  if(!canRequest()) {
    return;
  }

  await axios.post(`${SettingsContext.getApiUrl('enablePartialSponsoring')}/${companyId}`);
};

type CompanyPoints = {
  enabled: boolean;
  points: number;
}

type JobPoint = {
  postingId: number;
  points: number;
}